import { render, staticRenderFns } from "./reasink.vue?vue&type=template&id=8132a29c&scoped=true"
import script from "./reasink.vue?vue&type=script&lang=js"
export * from "./reasink.vue?vue&type=script&lang=js"
import style0 from "./reasink.vue?vue&type=style&index=0&id=8132a29c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8132a29c",
  null
  
)

export default component.exports